export const EditorMessages = {
    WARN_CHAR_LIMIT_TYPING: 'editor.char-limit-typing',
    WARN_CHAR_LIMIT_PASTING_AT_LIMIT: 'editor.char-limit-pasting-at-limit',
    WARN_CHAR_LIMIT_PASTING: 'editor.char-limit-pasting',
}